import React from 'react';

import { Alert } from 'antd';

import { RecommendationInsightVerificationFailureType } from 'types/recommendations';

import {
  RECOMMENDATION_VERIFICATION_FAILURE_DEFAULT_LABEL,
  RECOMMENDATION_VERIFICATION_FAILURE_LABELS,
} from './constants';

type Props = {
  failure: RecommendationInsightVerificationFailureType;
};

const getFailureDetails = (failure: RecommendationInsightVerificationFailureType): string[] => {
  const details = [];
  if (failure.missing_community_ids?.length) {
    details.push(`Missing community IDs: ${failure.missing_community_ids.join(', ')}`);
  }
  if (failure.validation_error) {
    details.push(failure.validation_error);
  }
  if (failure.attempts) {
    details.push(`Attempts: ${failure.attempts}`);
  }
  return details;
};

const RecommendationEvidenceVerificationFailure = ({ failure }: Props) => {
  const details = getFailureDetails(failure);
  return (
    <Alert
      type="warning"
      showIcon
      message={
        RECOMMENDATION_VERIFICATION_FAILURE_LABELS[failure.reason] || RECOMMENDATION_VERIFICATION_FAILURE_DEFAULT_LABEL
      }
      description={details.length ? details.join(' · ') : undefined}
      data-test-id="aici-website-evidence-verification-failure"
    />
  );
};

export default RecommendationEvidenceVerificationFailure;
